module.exports = __webpack_public_path__ + "img/logo2.983ef345.png";